const getUpgradeArPlansDictionary = function (data) {
  const upgradeArPlansDictionary = {
    trademo_intel_ar_pro: {
      name: "Trademo intel argentina Pro",
      key: "trademo_intel_ar_pro",
      upgradeMessageArrivalDate: "You have access last 12 months of trade data. To access complete data. ",
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts  ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access last 12 months of trade data. To access complete data.",
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Last 12 months shipments data", "Unlimited searches per day", "120,000 shipment downloads per user annually"],
    },
    trademo_intel_ar_advanced: {
      name: "Trademo intel argentina Advanced",
      key: "trademo_intel_ar_advanced",
      upgradeMessageArrivalDate: "You have access last 24 months of trade data. To access complete data. ",
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts ",
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access last 24 months of trade data. To access complete data.",
      dashboardUpgradeMessageEmailAlert: "Never miss out on tracking important shipments.",
      planFeatures: ["Last 24 months shipments data", "US Census Data based Product Trends for last 24 months", "300,000 shipment downloads per user annually"],
    },
    trademo_intel_ar_enterprise: {
      name: "Trademo intel argentina enterprise",
      key: "trademo_intel_ar_enterprise",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent  Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You do not have sufficient credits available to set Email Alert. To set more alerts ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent  Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: ["Jan 2015 - Present shipments data", "Unlimited downloads per user"],
    },
  };
  return upgradeArPlansDictionary;
};
exports.getUpgradeArPlansDictionary = getUpgradeArPlansDictionary;
